module.exports = __webpack_public_path__ + "static/img/coin-off.188a8455.png";